export default __webpack_public_path__ + "src/assets/remove.c75d824f70cb880cc361633decd1e2a4.svg";